// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3ed28473","455":"7ef12789","977":"4c2d0707"}[chunkId] + ".chunk.js";
};